var _defs, _g, _path, _line, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerdidaEquipaje(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 336 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#b1afb0;stroke-miterlimit:10;stroke-width:3.02px;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#f7f8f9;}.cls-5{fill:#fff;}.cls-6{fill:#fec800;}.cls-7{fill:#aecb39;}.cls-8{fill:#e2e0de;}.cls-9{fill:#07599b;}.cls-10{fill:#258dcd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.4,
    y: 162,
    width: 122.88,
    height: 122.88
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M159.25,271.37H66.43c-4.91,0-8.89-4.21-8.89-9.4v-56.64c0-5.2,3.98-9.41,8.89-9.41h92.82c4.91,0,8.89,4.21,8.89,9.41v56.64c0,5.19-3.98,9.4-8.89,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66.38,271.37h13.27c-.04-12.18-9.92-22.04-22.11-22.04v13.21c0,4.88,3.96,8.83,8.83,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.27,271.37h-13.24c.04-12.18,9.92-22.04,22.11-22.04v13.18c0,4.9-3.97,8.87-8.87,8.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.76,231.23h-1.83c-3.18,0-5.75-2.57-5.75-5.75v-5.75h13.33v5.75c0,3.17-2.57,5.75-5.75,5.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 106.18,
    y: 195.92,
    width: 13.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.49,175.52h-39.3c-4.24,0-7.69,3.44-7.69,7.69v12.81h6.83v-13.67h41.01v13.67h6.83v-12.81c0-4.25-3.44-7.69-7.69-7.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 92.34,
    y: 182.35,
    width: 41.01,
    height: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.02,230.45c.86,.51,1.84,.81,2.91,.81h1.83c3.17,0,5.75-2.57,5.75-5.75v-5.56l-10.49,10.49Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M238.42,82.84c.28-2.45-.52-4.77-2.01-6.51-1.38-2.01-3.35-2.81-5.4-2.95-.04,0-.07-.02-.11-.02-1.23-.14-2.43,0-3.54,.35-2.99,.66-5.43,2.04-5.43,2.04l-24,10.14-64.89-20.24-12.34,6.19,45.21,28.67-24.6,9.9-20.29-10.62-10.64,4.39,16.21,12.42-12.6,6.19s-.05,.09-.11,.22c-1.35,.81-2.33,2.2-2.52,3.88-.33,2.88,1.73,5.48,4.61,5.82,.38,.04,.76,.04,1.13,0,1.38,.07,3.11-.12,5.38-.71,17.51-4.6,109.19-41.38,109.98-41.86,.15-.09,.25-.19,.39-.28,2.94-1.07,5.2-3.7,5.59-7.02"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.76,
    y1: 271.32,
    x2: 269.76,
    y2: 271.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M247.69,182.37c1.32-14.05-5.65-28.19-18.83-35.36-13.18-7.17-28.84-5.34-39.91,3.4l58.74,31.95Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "213.9 155.79 213.9 194.91 213.89 273.88 222.8 273.88 222.8 194.91 222.8 155.79 213.9 155.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285.35,143.54c-7.06-12.22-20.93-19.71-35.83-17.92-14.9,1.79-26.6,12.35-30.57,25.89l66.39-7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.31,179.72c-.52-14.1,7.24-27.82,20.8-34.23,13.57-6.42,29.09-3.7,39.66,5.65l-60.46,28.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.41,207.07c-7.65-11.85-7.99-27.62,.39-40.06,8.38-12.44,23.12-18.04,36.98-15.4l-37.37,55.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155.94,139.43c7.74-11.8,22.01-18.49,36.78-15.86,14.77,2.63,25.86,13.83,29.06,27.58l-65.84-11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.66,205.95c7.07-12.21,6.65-27.96-2.32-39.99-8.98-12.02-23.96-16.9-37.68-13.59l40,53.58Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerdidaEquipaje);
export default __webpack_public_path__ + "static/media/PerdidaEquipaje.6f07dca9206f2d54304b10ca7ffbce73.svg";
export { ForwardRef as ReactComponent };